<!--suppress CssUnusedSymbol -->
<template>
  <div id="app" v-bind:class="{
    'show-main-menu-full' : menuMainOpened,
    'header-fixed' : !isLoginPage,
    'show-main-menu' : isStationPage,
    'weather-class' : showTransitionClass
  }">
    <MainMenu v-if="!isLoginPage && hasSideMenu"></MainMenu>
    <Header v-if="!isLoginPage"></Header>
    <div id="content_" class="section-box-content">
      <router-view></router-view>
    </div>
    <transition name="fade">
      <div @click="toggleMenu()" id="mobOverlay" class="mob-overlay" v-show="menuOpened"></div>
    </transition>
    <Footer v-if="isLoginPage"></Footer>
    <notifications group="foo"/>
  </div>
</template>

<script>
import Header from './components/layots/Header'
import Footer from './components/layots/Footer'
import MainMenu from './components/layots/MainMenu.vue'

export default {
  components: {
    Header,
    Footer,
    MainMenu
  },
  computed: {
    isLoginPage () {
      return (this.$route.name === 'login')
    },
    menuOpened () {
      return this.$store.getters[ 'common/menuIsOpened' ]
    },
    showTransitionClass () {
      return this.$store.getters[ 'common/showTransitionClass' ]
    },
    menuMainOpened () {
      return this.$store.getters[ 'common/menuMainIsOpened' ]
    },
    isStationPage () {
      return this.$store.getters[ 'station/hasStation' ]
    },
    hasSideMenu () {
      return (this.$route.meta.noMenu === undefined) || (this.$route.meta.noMenu === false)
    }
  },
  beforeCreate () {
    this.$store.dispatch('security/loadToken')
  },
  methods: {
    toggleMenu () {
      this.$store.dispatch('common/toggleMenu')
    }
  }
}

</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
